module.exports = __webpack_public_path__ + "static/woocommerce_logo_vertical-fc0a4988691ee08962e2a97a0254e735.png";